import React from 'react';
import { List } from 'react-admin';
import JourneyGrid from '../../components/JourneyGrid';

export const JourneyList = (props) => (
    <List title="My Journeys" {...props}>
        <JourneyGrid />
    </List>
);


// WEBPACK FOOTER //
// ./src/pages/lists/Journeys.js